module.exports = __webpack_public_path__ + "d889451d476029713aa3770e648c767b.png";